<template>
    <div>

        <transition name="modal">
            <div class="custom-modal" @click="closeDetailsModal()" v-if="modalVisible">

                <div class="custom-modal-window" style="min-height: 500px; width: 750px;" @click.stop>
                    <div class="btn-close" @click="closeDetailsModal()"></div>

                    <div v-if="modalItem">

                        <h2 class="mb-6">Intresseanmälan inom <span v-if="modalItem.product_area_id == 1">massage</span><span v-if="modalItem.product_area_id == 2">personlig träning</span></h2>

                        <div class="container-fluid">

                            <div class="row mb-2 pb-2 pt-2 border-bottom border-top">
                                <div class="col-9"><b>Namn</b></div>
                                <div class="col">{{ modalItem.name_person }}</div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Telefon</b></div>
                                <div class="col">{{ modalItem.phone }}</div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>E-post</b></div>
                                <div class="col">{{ modalItem.email }}</div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Ort</b></div>
                                <div class="col">{{ modalItem.city }}</div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Jag är</b></div>
                                <div class="col">
                                    <ul class="ps-4 mb-0">
                                        <li v-for="cert in splittoarray(modalItem.certifications)">{{ cert }}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Utbildning</b></div>
                                <div class="col">{{ modalItem.school }}</div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Jag har</b></div>
                                <div class="col">
                                    <ul class="ps-4 mb-0">
                                        <li v-for="doc in splittoarray(modalItem.documents)">{{ doc }}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Typ av mottagning</b></div>
                                <div class="col">
                                    <ul class="ps-4 mb-0">
                                        <li v-for="locality in splittoarray(modalItem.locality)">{{ locality }}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Hur hittade du oss?</b></div>
                                <div class="col">{{ modalItem.found_us_from }}</div>
                            </div>

                            <div class="row mb-2 pb-2 border-bottom">
                                <div class="col-9"><b>Meddelande</b></div>
                                <div class="col">{{ modalItem.message }}</div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </transition>

        <h1 class="mt-4">
            Search & intresse
        </h1>

        <div class="content-container">
            <div class="row g-3 mb-4">
                <div class="col-24 col-md-6">
                    <input
                        type="text"
                        class="form-control new-list-group-field"
                        placeholder="Sök personnamn, mottagning, certifieringar"
                        v-model="settings.query.text"
                    />
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.type">
                        <option :value="null">Typ</option>
                        <option :value="'scraping'">Search</option>
                        <option :value="'signup'">Intresseanmälan</option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.city">
                        <option :value="null">Ort</option>
                        <option :value="city.name" :key="'c'+city.name" v-for="city in options.cities" v-if="city.name != ''">{{ city.name }}</option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.product_area_id">
                        <option :value="null">Tjänsteområde</option>
                        <option :value="1">Massage</option>
                        <option :value="2">PT</option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.status">
                        <option :value="null">Status</option>
                        <option :value="'new'">Inhämtade</option>
                        <option :value="'imported'">Konverterade till prospects</option>
                        <option :value="'duplicate'">Raderade/dubletter</option>
                        <option :value="'possible_duplicate'">Möjliga dubletter</option>
                    </select>
                </div>

                <div class="col-24 col-md-9 d-flex justify-content-end d-none">
                    <button class="btn btn-primary btn-sm" @click="openExportModal()">
                        Spara Excel
                        <div class="tooltip-label">
                            Ladda ner en Excel-fil med search objekt.
                        </div>
                    </button>
                </div>
            </div>

            <div class="custom-list-wrapper">
                <list ref="list" :settings="settings" :query.sync="settings.query">
                    <div slot="item-row" slot-scope="props">

                        <div class="list-row-container" :class="props.item.status">
                            <div class="row py-1">

                                <div class="col d-flex align-items-start col-md-1">
                                    <div><span>{{ props.item.id }}</span></div>
                                </div>

                                <div class="col d-flex align-items-start col-md-2">
                                    <div class="tooltip-target h-100">
                                        <span>{{ formatDate(props.item.parsed_at) }}</span>
                                        <div class="tooltip-label tooltip-label-white">
                                            {{ props.item.parsed_at }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col d-flex align-items-start col-md-1">
                                    <div class="tooltip-target h-100">
                                        <span class="badge badge-secondary ms-0 mb-2" v-if="props.item.type == 'scraping'">Search</span>
                                        <span class="badge badge-primary ms-0 mb-2" v-if="props.item.type == 'signup'">Intresse</span>
                                        <span class="badge badge-warning ms-0" v-if="props.item.status == 'possible_duplicate'">Dublett</span>
                                        <span class="badge badge-secondary ms-0" v-if="props.item.status == 'imported'">Prospect</span>
                                        <span class="badge badge-danger ms-0" v-if="props.item.status == 'duplicate'">Raderad</span>

                                        <div class="tooltip-label tooltip-label-white" v-if="props.item.possible_duplicates">
                                            <div><b>Matchade partners/prospects:</b></div>
                                            <div v-for="duplicate in props.item.possible_duplicates"><a :href="'/clinics/'+duplicate.id" target="_blank">{{ duplicate.name_person }}</a><span v-if="duplicate.name_clinic">, {{ duplicate.name_clinic }}</span></div>
                                        </div>
                                    </div>

                                </div>

                                <div class="col d-block col-md-3">
                                    <div class="w-100">
                                        <b><span style="font-weight: 400;">{{ props.item.name_person }}</span></b>
                                    </div>
                                    <span style="font-size:13px;" v-if="props.item.job_title">{{ props.item.job_title }}</span>

                                    <span style="font-size:13px;" v-if="props.item.product_area_id == 1 && props.item.type == 'signup'">Massör</span>

                                    <span style="font-size:13px;" v-if="props.item.product_area_id == 2 && props.item.type == 'signup'">Personlig tränare</span>

                                </div>

                                <div class="col d-block col-md-4">

                                    <div class="w-100" v-if="props.item.name_company"><b><span style="font-weight: 400;">{{ props.item.name_company }}</span></b></div>

                                    <div v-if="props.item.product_area_id == 1">
                                        <div class="w-100" v-if="props.item.locality == 'Egen mottagning i extern lokal'"><b><span style="font-weight: 400;">Mottagning</span></b></div>
                                        <div class="w-100" v-if="props.item.locality == 'Egen mottagning i eller i anslutning till mitt hem'"><b><span style="font-weight: 400;">Mottagning i hemmet</span></b></div>
                                    </div>

                                    <div style="font-size:13px;" v-if="props.item.city">{{ props.item.city }}</div>

                                    <div style="font-size:13px;" v-if="props.item.email"><a :href="'mailto:'+props.item.email">{{ props.item.email }}</a></div>
                                    <div style="font-size:13px;" v-if="props.item.phone">{{ props.item.phone }}</div>
                                </div>

                                <div class="col d-block col-md-1">
                                    <span style="white-space: nowrap;" v-if="props.item.rating && props.item.rating != 0"><span style="color:orange;">★</span> {{ formatRating(props.item.rating) }}</span>
                                </div>

                                <div class="col d-flex align-items-start col-md-2">

                                    <div class="tooltip-target h-100">
                                        <div v-for="cert in splittoarray(props.item.certifications)" v-if="props.item.certifications">
                                            <img src="images/admin/sveriges-naprapater.png" class="cert-img me-2" v-if="cert == 'Svenska Naprapatförbundet'">
                                            <img src="images/admin/svenska-friskvardsforbundet.png" class="cert-img me-2" v-else-if="cert == 'Svenska Friskvårdsförbundet'">
                                            <img src="images/admin/yrkesmassorernas-forbund.png" class="cert-img me-2" v-else-if="cert == 'Yrkesmassörernas Förbund'">
                                            <img src="images/admin/kroppsterapeuternas-yrkesforbund.png" class="cert-img me-2" style="height:25px;" v-else-if="cert == 'Kroppsterapeuternas Yrkesförbund'">
                                            <span class="badge badge-info ms-0 mb-2" style="white-space: normal; line-height: 1.25" v-else>{{ cert }}</span>

                                        </div>
                                        <div class="tooltip-label tooltip-label-white">
                                            {{ props.item.certifications }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col d-flex align-items-start col-md-3">
                                    <div class="tooltip-target h-100" v-if="props.item.presentation">
                                        <span>{{ formatPresentation(props.item.presentation) }}...</span>
                                        <div class="tooltip-label tooltip-label-xl tooltip-label-white">
                                            {{ props.item.presentation }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col d-block col-md-3">
                                    <div class="d-flex w-100" v-if="props.item.price_30">
                                        <div style="width:60px;">30 min</div>
                                        <div>{{ props.item.price_30 }}</div>
                                    </div>
                                    <div class="d-flex w-100" v-if="props.item.price_45">
                                        <div style="width:60px;">45 min</div>
                                        <div>{{ props.item.price_45 }}</div>
                                    </div>
                                    <div class="d-flex w-100" v-if="props.item.price_60">
                                        <div style="width:60px;">60 min</div>
                                        <div>{{ props.item.price_60 }}</div>
                                    </div>
                                    <div class="d-flex w-100" v-if="props.item.price_90">
                                        <div style="width:60px;">90 min</div>
                                        <div>{{ props.item.price_90 }}</div>
                                    </div>
                                </div>

                                <div class="col d-flex align-items-start col-md-2">
                                    <div v-if="props.item.type == 'scraping'">
                                        <span v-if="props.item.source_url"><a class="btn btn-secondary btn-sm" :href="props.item.source_url" target="_blank" title="Källa"><img src="/images/admin/icon-new-window.svg" style="margin-top:3px;">{{ props.item.source }}</a></span>
                                        <span v-else>{{ props.item.source }}</span>
                                    </div>
                                    <div v-if="props.item.type == 'signup'">
                                        <span><a class="btn btn-secondary btn-sm" @click="openDetailsModal(props.item)" target="_blank">Visa anmälan</a></span>
                                    </div>
                                    <div v-if="props.item.website_url" class="mt-2">
                                        <a :href="websiteUrl(props.item.website_url)" target="_blank" class="website-link" title="Hemsida"><img src="/images/admin/icon-new-window-green.svg">Hemsida</a>
                                    </div>

                                </div>

                                <div class="col d-flex align-items-start justify-content-end col-md-2 pe-0">
                                    <button class="btn btn-danger btn-sm" @click="markDuplicate(props.item)" v-if="props.item.status != 'duplicate' && props.item.status != 'imported'">
                                        <img src="/images/admin/icon-trash.svg" class="me-0">
                                        <div class="tooltip-label tooltip-label-white">Släng - ointressant eller dublett</div>
                                    </button>
                                    <button class="btn btn-primary btn-sm ms-3" @click="createProspect(props.item)" v-if="props.item.status != 'imported'">
                                        <img src="/images/admin/icon-register.svg" class="me-0">
                                        <div class="tooltip-label tooltip-label-white">Konvertera till ett prospect</div>
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>
                </list>
            </div>

            <br><br>
            <a class="btn btn-primary" href="/scraper/upload">Ladda upp fil</a>

        </div>

    </div>
</template>

<script>
import lister from '../../shared/mixins/lister'
import axios from 'axios'

export default {
    mixins: [lister],

    props: {
        options: {
            required: true
        }
    },

    data () {
        return {
            settings: {
                url: '/scraper/list',
                query: {
                    type: null,
                    text: '',
                    city: null,
                    product_area_id: null,
                    status: 'new'
                },
                columns: [
                    {
                        column: 'id',
                        name: 'ID',
                        class: 'col col-md-1',
                        sortable: true,
                        default: true
                    },
                    {
                        column: 'parsed_at',
                        name: 'Datum',
                        class: 'col col-md-2',
                        sortable: true
                    },
                    {
                        column: 'type',
                        name: 'Typ',
                        class: 'col col-md-1',
                        sortable: true
                    },
                    {
                        column: 'name_person',
                        name: 'Namn',
                        class: 'col col-md-3',
                        sortable: true
                    },
                    {
                        column: 'name_company',
                        name: 'Företag/kontakt',
                        class: 'col col-md-4',
                        sortable: true
                    },
                    {
                        column: 'rating',
                        name: 'Betyg',
                        class: 'col col-md-1',
                        sortable: true
                    },
                    {
                        column: 'certifications',
                        name: 'Utb./Förs.',
                        class: 'col col-md-2',
                        sortable: true
                    },
                    {
                        column: 'presentation',
                        name: 'Presentation',
                        class: 'col col-md-3',
                        sortable: true
                    },
                    {
                        column: 'price_60',
                        name: 'Priser',
                        class: 'col col-md-3',
                        sortable: true
                    },
                    {
                        column: 'source',
                        name: 'Källa & hemsida',
                        class: 'col col-md-4',
                        sortable: true
                    }

                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'id', name: 'ID' },
                    { column: 'created_at', name: 'Inkommet' }
                ]
            },
            modalItem: null,
            modalVisible: false
        }
    },

    computed: {},

    methods: {

        createProspect (scrapeObject) {
            axios.post(
                '/scraper/' + scrapeObject.id + '/createProspect'
            )
                .then(response => {
                    console.log('createProspect')
                    console.log(response.data)

                    window.location.href = '/clinics/' + response.data.clinic_id
                })
                .catch(error => {
                    alert('Misslyckades, vänligen försök igen.')
                })
        },

        markDuplicate (scrapeObject) {
            axios.post(
                '/scraper/' + scrapeObject.id + '/markDuplicate'
            )
                .then(response => {
                    console.log('markDuplicate')
                    console.log(response.data)

                    this.refresh()
                })
                .catch(error => {
                    alert('Misslyckades, vänligen försök igen.')
                })
        },
        formatDate (date) {
            if (date != null) {
                return date.substr(0, 10)
            }
        },
        formatRating (rating) {
            if (rating != null) {
                const num = Number(rating)
                const rounded = Number(num.toFixed(1))
                return rounded
            }
        },
        splittoarray (string) {
            if (string != null) {
                return string.split(',')
            }
        },
        formatPresentation (presentation) {
            if (presentation != null) {
                return presentation.substr(0, 75)
            }
        },
        openDetailsModal (item) {
            this.modalItem = item
            this.modalVisible = true
            jQuery('html').addClass('modal-open')
        },
        closeDetailsModal () {
            this.modalItem = null
            this.modalVisible = false
            jQuery('html').removeClass('modal-open')
        },
        websiteUrl(url){
            if (!url) return '';
            return /^https?:\/\//i.test(url)
              ? url
              : `https://${url}`;
        }

    }
}
</script>
<style type="text/css">
/* --- Fade transition --- */
.modal-enter-active, .modal-leave-active {
    opacity: 1;
    transition: all 250ms;
}

.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 250ms;
}

.modal-enter, .modal-leave-to {
    opacity: 0;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, -50px);
}
</style>
